import React, { createContext, useState, useContext } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

import { AuthContext } from "./AuthContext";
import { ScreenContext } from "./ScreenContext";

export const InventoryContext = createContext();

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

const InventoryContextProvider = (props) => {
  const { user, token } = useContext(AuthContext);
  const { setSnackbarMessage } = useContext(ScreenContext);

  const [isLoading, setLoading] = useState(false);
  const [invItems, setInvItems] = useState([]);
  const [invItemDetails, setItemDetails] = useState([]);

  const getInventoryItemDetails = (id) => {
    // setLoading(true);
    let source = axios.CancelToken.source();

    axios
      .get(API_URL + "get-inventory-items", {
        cancelToken: source.token,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        params: { id: `${id}` },
      })
      .then((res) => {

        let items = [];
        res.data.value.map((data) => {
          let item = {
            id: data.ID,
            ItemName: data.ItemLink_x003a_ItemName.Value,
            ItemNotes: data.Notes,
            ItemClient: data.Client ? data.Client : "",
            ItemLocation: data.Location,
            ItemImage: data.ItemLink_x003a_ItemImage.Value,
            ItemQty: data.Qty,
            ItemPrice: data.Price,
            ItemAction: data.Title,
            ItemActionDate: data.Created,
            ItemActionWho: data.Who.DisplayName,
          };

          items.push(item);
        });

        setItemDetails(items);
        // setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          setSnackbarMessage({
            message: error.response.status,
            severity: "error",
          });
        }
        // setLoading(false);
      });

    //Cancel axios request when component unmounted
    return () => {
      // setLoading(false);
      source.cancel();
    };
  };

  const getInventoryItems = () => {
    setLoading(true);
    let source = axios.CancelToken.source();

    axios
      .get(API_URL + "get-inventory-items", {
        cancelToken: source.token,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {

        let items = [];
        res.data.value.map((data) => {
          let item = {
            id: data.ID,
            ItemName: data.Title,
            ItemDescription: data.ItemDescription,
            ItemLocation: data.ItemLocation,
            ItemImage: data.ItemImage,
            ItemQty: data.ItemQty,
            ItemCostPrice: data.ItemCostPrices,
            ItemStatus: data.ItemStatus,
          };

          items.push(item);
        });

        setInvItems(items);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          setSnackbarMessage({
            message: error.response.status,
            severity: "error",
          });
        }
        setLoading(false);
      });

    //Cancel axios request when component unmounted
    return () => {
      // setLoading(false);
      source.cancel();
    };
  };

  const saveInventoryItem = (fdata, file) => {



    setLoading(true);
    const formData = new FormData();
    let source = axios.CancelToken.source();

    if (file) {
      let fileext = file.name.slice(
        (Math.max(0, file.name.lastIndexOf(".")) || Infinity) + 1
      );
      let uuid = uuidv4();
      let newFileName = `${uuid}.${fileext}`;
      formData.append("upload", file, newFileName);
    }

    formData.append("id", fdata.id);
    formData.append("formAction", fdata.formAction);
    formData.append("who", user.email);
    formData.append("name", fdata.name);
    formData.append("location", fdata.location);
    formData.append("desc", fdata.desc);
    formData.append("notes", fdata.notes);
    formData.append("client", fdata.client);
    formData.append("qty", fdata.qty);
    formData.append("cp", fdata.cp);
    formData.append("sp", fdata.sp);
    formData.append("status", fdata.status);
    formData.append("image", fdata.image);
    formData.append("action", fdata.action);

    axios
      .post(API_URL + "save-inventory-item", formData, {
        cancelToken: source.token,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {

        // setLoading(false);

        getInventoryItems();

        setSnackbarMessage({
          message: `inventory-item saved`,
          severity: "success",
        });
      })
      .catch((error) => {
        if (error.response) {
          setSnackbarMessage({
            message: error.response.status,
            severity: "error",
          });
        }
        setLoading(false);
      });

    //Cancel axios request when component unmounted
    return () => {
      // setLoading(false);
      source.cancel();
    };
  };

  return (
    <InventoryContext.Provider
      value={{
        invItems,
        getInventoryItems,
        saveInventoryItem,
        invItemDetails,
        setItemDetails,
        getInventoryItemDetails,
        isLoading,
      }}
    >
      {props.children}
    </InventoryContext.Provider>
  );
};

export default InventoryContextProvider;
